// @flow
import React from 'react';

import { SiteContainer } from 'Components/frameworks/site-container/SiteContainer.jsx';
import { addTranslationKeys } from 'Src/i18n';
import { CruiseBookingContainer } from 'Components/widgets/cruise-booking/CruiseBooking.container';
import {
  type LineProps,
  type ResolvedProps,
} from 'Client/cms/toolkit/cruise-booking/cruiseBooking.resolver';

export type Props = {
  ...$Exact<ResolvedProps>,
  ...$Exact<LineProps>,
};

export const CruiseBookingLine = ({ id, ...props }: Props) => {
  addTranslationKeys({ booking: props.booking, criteria: props.criteria, config: props.config });

  return (
    <SiteContainer id={id} className="Line">
      <CruiseBookingContainer {...props} />
    </SiteContainer>
  );
};
